import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { LanguageService } from '../services/language/language.service';
import { environment } from '../../../environments/environment';
import { AuthService } from '../services/auth/auth.service';
import { StorageKey } from '../constants/storage.constant';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token =
    inject(AuthService).userData()?.auth?.token ??
    localStorage.getItem(StorageKey.OTP_TOKEN);

  req = req.clone({
    headers: req.headers
      .set('language', inject(LanguageService).currentLang())
      .set('X-Authorization', environment.auth_key)
      .set('Authorization', `Bearer ${token}`),
  });

  return next(req);
};
